import { Button, Input, Modal, Space, Table, Tag } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { OutboundModalItem, OutboundRequestTag } from './entry.types';
import { getOutboundImportModalColumns } from './outbound-import-modal-columns';

type OutboundImportSectionProps = {
  outboundInputId: string;
  outboundLoading: boolean;
  onInputChange: (value: string) => void;
  onImport: () => void;
};

export function OutboundImportSection({
  outboundInputId,
  outboundLoading,
  onInputChange,
  onImport,
}: OutboundImportSectionProps) {
  return (
    <Space.Compact style={{ width: '100%', maxWidth: 520 }}>
      <Input
        placeholder="VD: #48017"
        value={outboundInputId}
        onChange={e => onInputChange(e.target.value)}
        onPressEnter={onImport}
        disabled={outboundLoading}
      />
      <Button type="primary" loading={outboundLoading} onClick={onImport}>
        Nhập lệnh xuất kho
      </Button>
    </Space.Compact>
  );
}

export function OutboundImportTags({
  tags,
  onRemoveTag,
}: {
  tags: OutboundRequestTag[];
  onRemoveTag: (id: string) => void;
}) {
  if (!tags.length) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {tags.map(tag => (
        <Tag
          key={tag.id}
          color={tag.status === 'cancelled' ? 'red' : 'green'}
          closable
          onClose={e => {
            e.preventDefault();
            onRemoveTag(tag.id);
          }}
          icon={tag.status === 'cancelled' ? <ExclamationCircleOutlined /> : undefined}
        >
          #{tag.id}
        </Tag>
      ))}
    </div>
  );
}

type OutboundImportModalProps = {
  open: boolean;
  pendingOutboundId: string;
  items: OutboundModalItem[];
  existingSkuQuantities: Map<string, number>;
  isDuplicateOutboundSku: (record: OutboundModalItem) => boolean;
  onClose: () => void;
  onConfirm: () => void;
  onToggleItem: (key: string, selected: boolean) => void;
};

export function OutboundImportModal({
  open,
  pendingOutboundId,
  items,
  existingSkuQuantities,
  isDuplicateOutboundSku,
  onClose,
  onConfirm,
  onToggleItem,
}: OutboundImportModalProps) {
  return (
    <Modal
      title={`Lệnh xuất kho #${pendingOutboundId}`}
      open={open}
      onCancel={onClose}
      onOk={onConfirm}
      okText="Xác nhận import"
      cancelText="Hủy"
      width={960}
      destroyOnClose
    >
      <Table
        dataSource={items}
        rowKey="key"
        pagination={false}
        size="small"
        scroll={{ x: 800 }}
        rowClassName={record => (isDuplicateOutboundSku(record) ? '[&>td]:!bg-amber-50' : '')}
        columns={getOutboundImportModalColumns({
          existingSkuQuantities,
          isDuplicateOutboundSku,
          onToggleItem,
        })}
      />
    </Modal>
  );
}
